import { InputSelect } from "#common/input/InputSelect"
import { MESES, STATUS_COURSE, TARJETA_COLOR } from "#training/constants"
import { Box, Stack } from "@mui/material"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { useMemo, useState } from "react"
import { toast } from "react-toastify"

const TableCellMonth = () => {
	let cell = []
	for (let index = 0; index < 12; index++) {
		cell.push(
			<TableCell
				key={"cell" + index + 1}
				style={{
					color: "#333",
				}}
			>
				{index < 9 ? `0${index + 1}` : index + 1}
			</TableCell>,
		)
	}
	return cell
}

const StatisticsResumen = ({ data }) => {
	const { colaboradores } = data
	const colaboradores_index = useMemo(() => Object.keys(colaboradores), [colaboradores])

	const cells = useMemo(() => {
		const styleCell = {
			backgroundColor: "#f0f0f0",
			color: "#333",
			padding: "5px",
			fontSize: { lap: "16px", lg: "20px" },
			whiteSpace: "nowrap", // evita que se parta en varias líneas
		}
		return colaboradores_index.map((colaborador) => (
			<TableRow key={colaborador}>
				<TableCell
					sx={{
						width: "1px",
						...styleCell,
					}}
				>
					{colaborador}
				</TableCell>
				<TableCell
					sx={{
						textAlign: "center",
						whiteSpace: "nowrap", // evita que se parta en varias líneas
						...styleCell,
					}}
				>
					{colaboradores[colaborador].count}
				</TableCell>
				<TableCellColor colaborador={colaborador} data={colaboradores[colaborador]} />
			</TableRow>
		))
	}, [colaboradores, colaboradores_index])

	return (
		<Box
			m={2}
			display="flex"
			flexDirection="row-reverse"
			gap={4}
			alignItems={"flex-start"}
			justifyContent="left"
		>
			<ControlTable data={colaboradores} />
			<Box>
				<TableContainer component={Paper}>
					<Table
						sx={{
							width: "50%",
							borderCollapse: "separate",
							borderSpacing: "4px", // separa horizontal y vertical
						}}
					>
						<TableHead key={"tbh01"}>
							<TableRow>
								<TableCell key={"c1"}>Colaborador</TableCell>
								<TableCell key={"c2"}>Total</TableCell>
								<TableCellMonth />
							</TableRow>
						</TableHead>

						<TableBody>{cells}</TableBody>
					</Table>
				</TableContainer>
			</Box>
		</Box>
	)
}
export default StatisticsResumen

const TableCellColor = ({ colaborador, data }) => {
	const cells = []
	for (let month = 1; month < 13; month++) {
		const cursos = data.cursos.filter((curso) => curso.mes === month)
		const multiple = cursos.length > 1

		cells.push(
			<TableCell
				key={colaborador + month + cursos[0]?.id}
				width={"100%"}
				sx={{
					// border: cursos.length ? "" : "2px solid #000000",
					backgroundColor: multiple
						? "#ffffff"
						: (TARJETA_COLOR[cursos[0]?.status_id] ?? "#ffffff"),
					textAlign: "center",
					borderRadius: 2,
					padding: "5px",
					fontSize: { lap: "10px", lg: "20px" },
					fontWeight: "bold",
				}}
			>
				{multiple ? (
					<Box
						display="flex"
						flexWrap="wrap"
						gap={0.5}
						justifyContent="center"
						alignItems="center"
					>
						{cursos.map((c) => (
							<Box
								key={c.id}
								sx={{
									width: 14,
									height: 14,
									borderRadius: "50%",
									backgroundColor: TARJETA_COLOR[c.status_id] ?? "#ffffff",
									border: "1px solid rgba(0,0,0,0.25)",
									flexShrink: 0,
								}}
							/>
						))}
					</Box>
				) : (
					""
				)}
			</TableCell>
		)
	}
	return cells
}

const ControlTable = ({ data }) => {
	const [selectMonth, setSelectMonth] = useState({ mesStar: 1, mesEnd: 12 })
	const { course_approved, course_count } = useMemo(() => {
		let course_count = 0
		let course_approved = 0

		Object.values(data).forEach(({ cursos }) => {
			cursos.forEach((element) => {
				if (element.mes >= selectMonth.mesStar && element.mes <= selectMonth.mesEnd) {
					course_count++
					if (element.status_id === STATUS_COURSE.APROBADO) course_approved++
				}
			})
		})
		return { course_count, course_approved }
	}, [selectMonth])

	return (
		<Box>
			mes inicio {selectMonth.mesStar} mes fin {selectMonth.mesEnd}
			<Stack direction={{ sm: "row", sx: "column" }} spacing={2} justifyContent={"left"}>
				<InputSelect
					label="inicio"
					data={MESES.slice(1)}
					setValue={(mes) => {
						if (mes > selectMonth.mesEnd) {
							toast.error("El inicio no puede ser menor que el fin.")
							return
						}
						setSelectMonth({ ...selectMonth, mesStar: mes })
					}}
					value={selectMonth.mesStar}
					dataLabel="label"
					dataId="id"
				/>
				<InputSelect
					label="Fin"
					data={MESES.slice(1)}
					setValue={(mes) => {
						if (mes < selectMonth.mesStar) {
							toast.error("El fin no puede ser mayor que el inicio.")
							return
						}
						setSelectMonth({ ...selectMonth, mesEnd: mes })
					}}
					value={selectMonth.mesEnd}
					dataLabel="label"
					dataId="id"
				/>
			</Stack>
			<TableContainer component={Paper}>
				<Table aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell>
								<h2>🗓️</h2>
							</TableCell>
							<TableCell>Plan</TableCell>
							<TableCell>Real</TableCell>
							<TableCell>porcentaje</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<TableRow>
							<TableCell>
								<h2>Plan Anual</h2>
							</TableCell>
							<TableCell>{course_count}</TableCell>
							<TableCell>{course_approved}</TableCell>
							<TableCell>
								{((course_approved / course_count) * 100).toFixed(2) | 0}%
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	)
}
